import { UIElement } from '../ui-element';
import { rebuildChildren } from '../../global/ui-helpers';
import { html } from '../../global/template-literals';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import type { UIFlagGlyph } from './ui-icon.types';
import styles from './ui-icon-flag.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIIconFlag
 * @element ui-icon-flag
 * @classdesc Represents a class for <code>ui-icon-flag</code> element.
 * @property {UIFlagGlyph} code {@attr code} Flag for the inner content.
 * @example
 * <ui-icon-flag code="ee"></ui-icon-flag>
 */
@Component({
    tag: 'ui-icon-flag',
    styles,
})
export class UIIconFlag extends UIElement {
    @Attribute(String) code?: UIFlagGlyph;

    /**
     * @type {string[]}
     */
    static get observedAttributes(): Array<string> {
        return [...super.observedAttributes, 'code'];
    }

    /**
     * Render or rebuild ui-icon mark up.
     */
    renderIconLayout(): void {
        const flag = html` <span class="${'-flag ' + this.code}"></span> `;
        rebuildChildren(this, this.code ? flag : []);
    }

    /**
     * @inheritDoc
     */
    observeAttributes(
        name: string,
        oldValue: string | null,
        newValue: string | null
    ): void {
        switch (name) {
            case 'code':
                this.renderIconLayout();
                break;
            /* istanbul ignore next */
            default:
                break;
        }
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.renderIconLayout();
    }
}
